import React from "react";
import styled from "styled-components";
import { FormGroup, ControlLabel, HelpBlock, Radio } from "components/bootstrap";
import { THRESHOLD_MODES } from "license/traffic/types";
const StyledControlLabel = styled(ControlLabel)`
  margin-bottom: ${({ theme }) => theme.spacings.sm};
`;
const RadioGroup = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacings.md};

  .radio {
    margin-top: 0;
    margin-bottom: 0;
  }
`;
const ThresholdTypeRadioSelector = ({ onChange, selectedThresholdMode }) => /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(StyledControlLabel, null, "Threshold Type"), /* @__PURE__ */ React.createElement(RadioGroup, null, /* @__PURE__ */ React.createElement(
  Radio,
  {
    name: "threshold_type",
    checked: selectedThresholdMode === THRESHOLD_MODES.PERCENTAGE,
    onChange: () => onChange(THRESHOLD_MODES.PERCENTAGE)
  },
  /* @__PURE__ */ React.createElement("strong", null, "Percentage (%)"),
  /* @__PURE__ */ React.createElement(HelpBlock, null, "Monitor percentage of daily license limit with accumulation from midnight.")
), /* @__PURE__ */ React.createElement(
  Radio,
  {
    name: "threshold_type",
    checked: selectedThresholdMode === THRESHOLD_MODES.ABSOLUTE,
    onChange: () => onChange(THRESHOLD_MODES.ABSOLUTE)
  },
  /* @__PURE__ */ React.createElement("strong", null, "Absolute (in GB)"),
  /* @__PURE__ */ React.createElement(HelpBlock, null, "Monitor absolute GB thresholds with accumulation from midnight.")
)));
export default ThresholdTypeRadioSelector;
